import React, { useState, useEffect } from 'react';
import '../../styles/admin/AdminCategories.css';

const AdminCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    description: ''
  });

  const API_BASE_URL = "https://phucansolutions.vn" || '"https://phucansolutions.vn"';

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('admin_token');
      
      const response = await fetch(`${API_BASE_URL}/api/admin/categories`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (response.ok && data.success) {
        setCategories(data.data);
      } else {
        alert('Lỗi: ' + data.error);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      alert('Lỗi kết nối server');
    } finally {
      setLoading(false);
    }
  };

  const generateSlug = (name) => {
    return name
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[đĐ]/g, 'd')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Auto-generate slug when name changes
    if (name === 'name') {
      setFormData(prev => ({
        ...prev,
        slug: generateSlug(value)
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.slug) {
      alert('Vui lòng điền đầy đủ thông tin');
      return;
    }

    try {
      const token = localStorage.getItem('admin_token');
      const url = editingCategory 
        ? `${API_BASE_URL}/api/admin/categories/${editingCategory.id}`
        : `${API_BASE_URL}/api/admin/categories`;
      
      const method = editingCategory ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method: method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      if (response.ok && data.success) {
        alert(editingCategory ? 'Cập nhật danh mục thành công!' : 'Tạo danh mục thành công!');
        fetchCategories();
        resetForm();
      } else {
        alert('Lỗi: ' + data.error);
      }
    } catch (error) {
      console.error('Error saving category:', error);
      alert('Lỗi kết nối server');
    }
  };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setFormData({
      name: category.name,
      slug: category.slug,
      description: category.description || ''
    });
    setShowCreateForm(true);
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Bạn có chắc muốn xóa danh mục "${name}"?\nLưu ý: Tất cả tin tức thuộc danh mục này sẽ bị ảnh hưởng.`)) {
      return;
    }

    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch(`${API_BASE_URL}/api/admin/categories/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();
      if (response.ok && data.success) {
        alert('Xóa danh mục thành công!');
        fetchCategories();
      } else {
        alert('Lỗi: ' + data.error);
      }
    } catch (error) {
      console.error('Error deleting category:', error);
      alert('Lỗi kết nối server');
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      slug: '',
      description: ''
    });
    setEditingCategory(null);
    setShowCreateForm(false);
  };

  return (
    <div className="admin-categories">
      <div className="categories-header">
        <div className="header-content">
          <h1>📂 Quản Lý Danh Mục</h1>
          <p>Quản lý danh mục tin tức và dự án</p>
        </div>
        <button 
          onClick={() => setShowCreateForm(true)}
          className="create-btn"
        >
          ➕ Tạo Danh Mục Mới
        </button>
      </div>

      {/* Create/Edit Form */}
      {showCreateForm && (
        <div className="form-overlay">
          <div className="form-modal">
            <div className="form-header">
              <h3>{editingCategory ? '✏️ Chỉnh sửa danh mục' : '➕ Tạo danh mục mới'}</h3>
              <button onClick={resetForm} className="close-btn">✖️</button>
            </div>
            
            <form onSubmit={handleSubmit} className="category-form">
              <div className="form-group">
                <label htmlFor="name">Tên danh mục *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Nhập tên danh mục..."
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="slug">Slug *</label>
                <input
                  type="text"
                  id="slug"
                  name="slug"
                  value={formData.slug}
                  onChange={handleInputChange}
                  placeholder="url-slug-tu-dong-tao"
                  required
                />
                <small>URL slug cho danh mục (tự động tạo từ tên)</small>
              </div>

              <div className="form-group">
                <label htmlFor="description">Mô tả</label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Mô tả về danh mục..."
                  rows="3"
                />
              </div>

              <div className="form-actions">
                <button type="button" onClick={resetForm} className="cancel-btn">
                  Hủy bỏ
                </button>
                <button type="submit" className="submit-btn">
                  {editingCategory ? '✅ Cập nhật' : '✅ Tạo mới'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Categories Table */}
      <div className="categories-table-container">
        {loading ? (
          <div className="loading-state">
            <div className="loading-spinner">🔄</div>
            <p>Đang tải danh mục...</p>
          </div>
        ) : (
          <table className="categories-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Tên danh mục</th>
                <th>Slug</th>
                <th>Mô tả</th>
                <th>Ngày tạo</th>
                <th>Thao tác</th>
              </tr>
            </thead>
            <tbody>
              {categories.length > 0 ? (
                categories.map((category) => (
                  <tr key={category.id}>
                    <td>{category.id}</td>
                    <td>
                      <strong>{category.name}</strong>
                    </td>
                    <td>
                      <code>{category.slug}</code>
                    </td>
                    <td>
                      <span className="description">
                        {category.description || 'Chưa có mô tả'}
                      </span>
                    </td>
                    <td>
                      <span className="date">
                        {new Date(category.createdAt).toLocaleDateString('vi-VN')}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          onClick={() => handleEdit(category)}
                          className="edit-btn"
                          title="Chỉnh sửa"
                        >
                          ✏️
                        </button>
                        <button
                          onClick={() => handleDelete(category.id, category.name)}
                          className="delete-btn"
                          title="Xóa"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="empty-state">
                    <div className="empty-content">
                      <p>📭 Chưa có danh mục nào</p>
                      <button 
                        onClick={() => setShowCreateForm(true)}
                        className="create-link"
                      >
                        Tạo danh mục đầu tiên
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminCategories; 